import CreateSeedRandom from "seed-random";

/**
 * Randomly picks up to `count` items from `items` driven by a seeded random
 * generator. The result keeps the original queue order. Returns an empty
 * array when `count` is 0 or `items` is empty.
 */
export const pickRandomItems = <Item>(items: Item[], count: number, seed: string) => {
  const random = CreateSeedRandom(seed);
  const pickedCount = Math.min(count, items.length);
  if (pickedCount === 0) return [];
  const indexes = items.map((_, index) => index);
  // Partial Fisher-Yates shuffle: only the first `pickedCount` positions are randomized.
  for (let index = 0; index < pickedCount; index++) {
    const swapIndex = index + Math.floor(random() * (indexes.length - index));
    [indexes[index], indexes[swapIndex]] = [indexes[swapIndex], indexes[index]];
  }
  const pickedIndexes = new Set(indexes.slice(0, pickedCount));
  return items.filter((_, index) => pickedIndexes.has(index));
};
